import { AngularEditorConfig } from '@kolkov/angular-editor';

/**
 * ERM-13220 — the composer's WYSIWYG setup. The editor's own toolbar is off:
 * the flat bold / italic / underline / list toolbar in the template drives it
 * through executeCommand instead. Sized for the drawer, which is narrower than
 * the dialog this replaced.
 */
export const CREATE_QUESTION_TODO_EDITOR_CONFIG: AngularEditorConfig = {
  editable: true,
  maxHeight: '14rem',
  minHeight: '7rem',
  outline: false,
  placeholder: '',
  sanitize: true,
  showToolbar: false,
  width: '100%',
};

/** The iris-be #5912 detail that means this question already carries a to-do. */
export const CREATE_QUESTION_TODO_DUPLICATE_DETAIL = 'already exists';

export const CREATE_QUESTION_TODO_FALLBACK_ERROR =
  "We couldn't create the to-do. Please try again.";

export const CREATE_QUESTION_TODO_DUPLICATE_ERROR =
  'This question already has an open to-do for the customer.';

/** ERM-13220 — the toast the composer raises for itself on a successful create. */
export const CREATE_QUESTION_TODO_SUCCESS_MESSAGE = 'To-do created.';

/**
 * The iris-be #5912 failures whose copy depends only on the status. A 400 is
 * deliberately absent: it splits on the response detail (duplicate anchor vs
 * the stage and version guards), so it is handled on its own. Anything not
 * listed (5xx, network) falls back to CREATE_QUESTION_TODO_FALLBACK_ERROR.
 */
export const CREATE_QUESTION_TODO_ERRORS_BY_STATUS: Readonly<
  Record<number, string>
> = {
  // The endpoint's permission decorator: the viewer's workspace grant was
  // revoked after the trigger rendered.
  403: 'You no longer have permission to create to-dos on this submission.',
  404: 'Customer to-dos are not available on this submission.',
  422: 'Please enter what you need from the customer.',
};
